import React from "react";
import { Link } from "react-router-dom";

const FooterLinks = ({ links }) => {
  const handleScrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <ul>
      {links.map((link, index) => (
        <li key={index}>
          <Link
            onClick={handleScrollToTop}
            className="footer-link"
            to={link.to}
          >
            {link.label}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default FooterLinks;
